import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class UpdateChangeListService {

  constructor(private http: HttpClient) { }

  updateGeneratedOn(
    baseUrl: string,
    returnClobSettingsObj: any,
    save_json: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    const url = `${baseUrl}/saveJsonObject?action_code=jvs67d`;

    // Support both legacy shape { globalParams: {...} } and migrated flat-params shape
    const gp = globalService?.globalParams || globalService || {};

    // Build AngularJS-compatible payload structure
    let params: any = _.merge({}, gp, filterParams);

    // Always assign last so nothing in gp/filterParams can overwrite the intended JSON
    params.clob_data = JSON.stringify(save_json || []);
    params.clob_settings = JSON.stringify(returnClobSettingsObj || {});

    // Add required configuration parameters with proper fallbacks
    params.tax_year = filterParams?.tax_year || gp?.tax_year || rowData?.TAX_YEAR || new Date().getFullYear();
    params.scenario = filterParams?.scenario || gp?.scenario || rowData?.SCENARIO || 74;
    params.jcd_key = filterParams?.jcd_key || gp?.jcd_key || rowData?.JCD_KEY || 250;
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || gp?.scenarioCode || gp?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || gp?.is_issue_key_enabled || 'N';
    params.sso_id = returnClobSettingsObj?.sso_id || gp?.sso_id || '';
    
    // Set process_name based on component
    params.process_name = "Update Generated On";

    // Use application/x-www-form-urlencoded (NOT json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }

  // Fetch max count entities method
  fetchMaxCountEntities(
    baseUrl: string,
    params: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      urlEncoded.set(key, params[key]);
    });

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
